import {
  getCatalogAppIds,
  getItemsCount,
  getItemTypes,
} from '../utils/bi.utils';
import { SiteStore } from '@wix/wixstores-client-storefront-sdk';
import { Cart } from './current-cart-service/types';

export class BIService {
  private readonly siteStore: SiteStore;

  constructor({ siteStore }: { siteStore: SiteStore; origin?: string }) {
    this.siteStore = siteStore;
  }

  public updateLineItemQuantity({
    origin,
    cart,
  }: {
    origin: string;
    cart: Cart;
  }) {
    return this.siteStore.platformBiLogger.updatedCartItemQuantitySf({
      origin,
      itemsCount: getItemsCount(cart.lineItems),
      cartId: cart._id!,
      catalogAppId: getCatalogAppIds(cart.lineItems),
      purchaseFlowId: cart.purchaseFlowId!,
    });
  }

  public removeCoupon({
    origin,
    cart,
    couponCode,
  }: {
    origin: string;
    cart: Cart;
    couponCode?: string;
  }) {
    return this.siteStore.platformBiLogger.removeACoupon({
      origin,
      cartId: cart._id!,
      catalogAppId: getCatalogAppIds(cart.lineItems),
      purchaseFlowId: cart.purchaseFlowId!,
      itemType: getItemTypes(cart.lineItems),
      couponCode,
    });
  }

  public addCoupon({
    origin,
    couponCode,
    cart,
  }: {
    origin: string;
    couponCode: string;
    cart: Cart;
  }) {
    return this.siteStore.platformBiLogger.clickApplyCoupon({
      origin,
      couponCode,
      catalogAppId: getCatalogAppIds(cart.lineItems),
      purchaseFlowId: cart.purchaseFlowId!,
    });
  }

  public removeLineItem({ cart, origin }: { cart: Cart; origin: string }) {
    return this.siteStore.platformBiLogger.removedProductFromCartSf({
      cartId: cart._id!,
      origin,
      itemsCount: getItemsCount(cart.lineItems),
      catalogAppId: getCatalogAppIds(cart.lineItems),
      purchaseFlowId: cart.purchaseFlowId!,
    });
  }
}
